// ============================================================
// HABIT OS — Bibliothek: Wärme, Kälte & Erholung
// Wärme · Kälte · Atmung · Erholung
// ============================================================

export const LIBRARY_LONGEVITY = {
  id: "longevity",
  label: "Wärme, Kälte & Erholung",
  icon: "🫀",
  subcategories: [

    // ── WÄRME, KÄLTE & ATMUNG ────────────────
    {
      id: "longevity_hormesis",
      label: "Wärme, Kälte & Atmung",
      icon: "⚡",
      habits: [
        {
          id: "hab_heat_hormesis",
          label: "Sauna als Hormesis",
          time: "flexible",
          icon: "🔥",
          why: "Saunabaden wird als wohltuender Wärmereiz geschätzt und kann zur Entspannung beitragen. Beobachtungsstudien zeigen Zusammenhänge mit Gesundheitswerten, aber keinen ursächlichen Nachweis.",
          source: "Laukkanen et al., JAMA Internal Medicine, 2015 · Laukkanen et al., Mayo Clinic Proceedings, 2018",
          dose: "2–4 Gänge à 8–15 Min., danach langsam abkühlen und ausreichend trinken. Bei Herz-Kreislauf-Erkrankungen, Bluthochdruck oder Schwangerschaft vorher ärztlich abklären.",
        },
        {
          id: "hab_cold_hormesis",
          label: "Kälte als Hormesis",
          time: "morning",
          icon: "🧊",
          why: "Kälteanwendungen wie kalte Duschen werden von vielen als belebend empfunden. Ihre Wirkung auf den Stoffwechsel ist beim Menschen noch nicht abschließend erforscht.",
          source: "Søberg et al., Cell Metabolism, 2021 · Šrámek et al., European Journal of Applied Physiology, 2000",
          dose: "Mit kurzen kalten Duschen (30–60 Sek.) beginnen und langsam steigern, nie allein ins kalte Wasser. Bei Herz-Kreislauf-Erkrankungen oder Bluthochdruck vorher ärztlich abklären.",
        },
        {
          id: "hab_hypoxia_training",
          label: "Atemübungen (Wim Hof / Box Breathing)",
          time: "morning",
          icon: "💨",
          why: "Atemübungen wie Box Breathing (4-4-4-4) können helfen, zur Ruhe zu kommen. Intensive Techniken wie die Wim-Hof-Atmung können Schwindel auslösen.",
          source: "Kox et al., PNAS, 2014 · Balban et al., Cell Reports Medicine, 2023",
          dose: "Box Breathing 5 Min. im Sitzen. Wim-Hof-Atmung nur sitzend oder liegend, nie im Wasser oder beim Autofahren; bei Epilepsie, Herzerkrankung oder Schwangerschaft vorher ärztlich abklären.",
        },
      ],
    },

    // ── ERHOLUNG & TRACKING ──────────────────
    {
      id: "longevity_biomarkers",
      label: "Erholung & Tracking",
      icon: "📊",
      habits: [
        {
          id: "hab_hrv_tracking",
          label: "Herzratenvariabilität (HRV) tracken",
          time: "morning",
          icon: "❤️",
          why: "Die HRV beschreibt die Schwankung zwischen Herzschlägen und wird oft als Hinweis auf Erholung und Stress genutzt. Wearable-Werte sind keine medizinische Diagnose.",
          source: "Plews et al., International Journal of Sports Physiology, 2013 · Shaffer & Ginsberg, Frontiers in Public Health, 2017",
          dose: "Täglich morgens, 3 Min. liegend messen · mit Brustgurt, Ring oder Uhr",
        },
      ],
    },
  ],
};